import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isObject as jt } from "../util/code-utils.js";
import { convertMsToSeconds as l, timestampOrNow as Jt } from "../util/date-utils.js";

var ue = /*#__PURE__*/function () {
  function ue(t, i, s, r, e) {
    _classCallCheck(this, ue);

    this.userId = t, this.type = i, this.time = Jt(s), this.sessionId = r, this.data = e;
  }

  _createClass(ue, [{
    key: "li",
    value: function li() {
      var t = {
        name: this.type,
        time: l(this.time),
        data: this.data || {},
        session_id: this.sessionId
      };
      return null != this.userId && (t.user_id = this.userId), t;
    }
  }, {
    key: "ss",
    value: function ss() {
      return {
        u: this.userId,
        t: this.type,
        ts: this.time,
        s: this.sessionId,
        d: this.data
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ue(t.user_id, t.name, t.time, t.session_id, t.data);
    }
  }, {
    key: "Ma",
    value: function Ma(t) {
      return null != t && jt(t) && null != t.t && "" !== t.t;
    }
  }, {
    key: "yn",
    value: function yn(t) {
      return new ue(t.u, t.t, t.ts, t.s, t.d);
    }
  }]);

  return ue;
}();

export { ue as default };